<template>
  <div class="login-container">
    <el-card class="login-card">
        <div slot="header" class="clearfix">
            <span class="title">官网后台管理系统登录</span>
        </div>
        <el-form
        :model="ruleForm"
        :rules="rules"
        status-icon ref="ruleForm"
        label-width="80px"
        class="demo-ruleForm">
          <el-form-item label="账号" prop = "username">
            <el-input
            type="text"
            v-model="ruleForm.username"
            autocomplete="off"
            placeholder="请输入账号"
            ></el-input>
          </el-form-item>
          <el-form-item label="密码" prop="password">
            <el-input
            type="password"
            v-model="ruleForm.password"
            autocomplete="off"
            show-password
            placeholder="请输入密码"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <span>
              <el-button type="primary" @click="submitForm('ruleForm')">登录</el-button>
              <el-button @click="resetForm('ruleForm')">重置</el-button>
            </span>
          </el-form-item>
        </el-form>
    </el-card>
  </div>
</template>

<script>
import {mapState,mapActions} from 'vuex'
export default {
    data(){
        return{
             ruleForm: {
                username: '',   //账号
                password: '',   //密码
            },
            rules:{
                username:[
                    { required: true, message: '帐号不能为空', trigger: 'blur' },
                    {min:1,max:18,message:'账号长度必须是1-18位',trigger:'blur'}
                    ],
                password:[
                    {required:true,message:'密码不能为空',trigger:'blur'},
                    {min:5,max:18,message:'密码长度必须是5-18位',trigger:'blur'}
                ]
            }
        }
    },
    computed:{
        ...mapState('login',['userToken'])
    },
    methods:{
        ...mapActions('login',['loginActions']),
        submitForm(formName){
        this.$refs[formName].validate((valid) => {
            if (valid) {
              //数据校验通过,直接发送ajax请求 完成用户注册
              this.loginActions(this.ruleForm)
              // axios.post('/sys/login',this.ruleForm).then(response =>{
              //     if (response.code === 200) {
              //         localStorage.setItem('token',JSON.stringify(response.data.token))
              //         router.push('/layout')
              //         Message({
              //             message:response.message,
              //             type:'success'
              //         })
              //     }else{
              //         Message({
              //             message:response.message,
              //             type:'error'
              //         })
              //     }
              // })
            } else {
                this.$message.warning('请检查账号密码是否正确');
                return false;
            }
        });
      },
    }
}
</script>

<style scope>
/* 设置背景 */
.login-container{
    width: 100vw;
    height: 100vh;
    background-image: url(@/assets/system/login_bg.jpg);
    background-size:cover;
    background-repeat: no-repeat;
    background-position: center center;
    display: flex;
    justify-content: center;
    align-items: center;
}
/* 设置登录form */
.login-card{
    width: 25vw;
    background-color: white;
    color: white;
}
.title{
  font-size: 20px;
  font-weight: 600;
  color: black !important;
}
/* .but{
  padding-left:4.5rem !important;
} */
.el-button--text{
  color:#999 !important;
  font-size: .8rem;
}
</style>